// mbi-validator.ts
import { AbstractControl, ValidationErrors } from '@angular/forms';

const INVALID_LETTERS = ['S', 'L', 'O', 'I', 'B', 'Z'];

export function mbiValidator(control: AbstractControl): ValidationErrors | null {
  const rawValue = control.value?.replace(/-/g, '').toUpperCase();

 // If the field is empty, return null (no validation error)
  if (!rawValue) {
    return null;
  }

  if (rawValue.length !== 11) {
    return { invalidLength: true };
  }


  const chars = rawValue.split('');

  const isLetter = (c: string) =>
    /^[A-Z]$/.test(c) && !INVALID_LETTERS.includes(c);
  const isDigit = (c: string) => /^[0-9]$/.test(c);
  const isDigit129 = (c: string) => /^[1-9]$/.test(c);
  const isAlphanumeric = (c: string) =>
    /^[A-Z0-9]$/.test(c) && !INVALID_LETTERS.includes(c);

  const rules = [
    isDigit129,    // Position 1
    isLetter,      // Position 2
    isAlphanumeric,// Position 3
    isDigit,       // Position 4
    isLetter,      // Position 5
    isAlphanumeric,// Position 6
    isDigit,       // Position 7
    isLetter,      // Position 8
    isLetter,      // Position 9
    isDigit,       // Position 10
    isDigit        // Position 11
  ];

  for (let i = 0; i < 11; i++) {
    if (!rules[i](chars[i])) {
      return { invalidFormat: true, invalidCharAt: i + 1 };
    }
  }

  return null;
}
